export default "/images/framework/ChangeAvatarEng.7c1d8652.svg?7c1d8652";